// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

import ErrorBoundary from 'components/error/ErrorBoundary';

import { TokenManager } from 'utils/security/securityUtil';

/**
 * @desc 보호된 경로를 위한 컴포넌트
 * - 인증되지 않은 경우 "/"로 리다이렉트
 * @param {React.Component} element - 보호된 경로에서 렌더링할 컴포넌트
 */
const ProtectedRoute = ({ element }) => {
  if (!localStorage.getItem(TokenManager.token.access)) {
    // 토큰이 없으면 리다이렉트
    return <Navigate to="/" />;
  }

  // 인증된 사용자는 요청한 컴포넌트를 렌더링
  return element;
};

export default ProtectedRoute;
